export default __webpack_public_path__ + "static/media/gallery_03.157c4d70.jpg";